import { councilCustomerApi } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export type UseDeleteCustomerParams = {
  onSuccess?: () => void
  onError?: () => void
}

const useDeleteCustomer = (options?: UseDeleteCustomerParams) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...(options?.onError ? { onError: options.onError } : {}),
    mutationFn: async ({
      councilId,
      customerId,
    }: {
      councilId: string
      customerId: string
    }) => {
      try {
        const response = await councilCustomerApi.deleteCouncilCustomer(councilId, customerId)
        return response.data
      } catch (error: unknown) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error as { response?: { data?: { message?: string } } }
          if (err.response?.data?.message) {
            throw new Error(err.response.data.message)
          }
        }
        throw error
      }
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["customers"] })
      queryClient.invalidateQueries({ queryKey: ["recent-customers"] })
      queryClient.invalidateQueries({
        queryKey: ["customerDetail", variables.councilId, variables.customerId],
      })
      options?.onSuccess?.()
    },
  })
}

export default useDeleteCustomer
